import { render, staticRenderFns } from "./PopupDocumentsList.vue?vue&type=template&id=7f5af09d"
import script from "./PopupDocumentsList.vue?vue&type=script&lang=ts"
export * from "./PopupDocumentsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports